////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { map, isArray } from 'lodash'
import { bindActionCreators } from 'redux'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
///////COMPONENTS///////
import Modals from '../../../Modals'
import TextParser from '../../helper/TextParser'
import { modalsActionCreators } from '../../../../store/actions'
import Button from '../../../Ui/Buttons'
import theme from '../../../../theme/theme'
import { ButtonWrapper } from '../../../../theme/GlobalCss'
import allReplace from '../../../../helpers/allReplace'

/////////ASSETS/////////
import Validation from '../../../../assets/icones/global/check.svg'

/////////STYLED/////////
const TooltipHelpModalWrapper = styled.div``
const ButtonWrapperExtra = styled(ButtonWrapper)`
	justify-content: center;
`
/////////STYLED/////////

const TooltipHelpModal = () => {
	const { translations, tooltipHelpData } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			tooltipHelpData: state.tooltipHelp,
		}),
		shallowEqual
	)

	const modalAction = bindActionCreators(modalsActionCreators, useDispatch())

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Modals
			title={translations['tooltipHelp__admin__modal__title']}
			showModal={tooltipHelpData.showModal}
			closeModalHandler={() => modalAction.tooltipHelpClose()}
			insideModalResponse={tooltipHelpData.insideModal}
			icon={true}
		>
			{
				// content can now be an array, so we need to iterate to translate all trad keys given
				isArray(tooltipHelpData.content)
					? map(tooltipHelpData.content, (tradKey) => {
							return map(TextParser.textFormat(translations[tradKey]), (elem, id) => (
								<p
									dangerouslySetInnerHTML={{ __html: allReplace(elem, '\\\\n', '<br>') /* elem.replaceAll('\\n','<br>') */ }}
									key={id}
								></p>
							))
					  })
					: map(TextParser.textFormat(translations[tooltipHelpData.content]), (elem, id) => (
							<p
								dangerouslySetInnerHTML={{ __html: allReplace(elem, '\\\\n', '<br>') /* elem.replaceAll('\\n','<br>') */ }}
								key={id}
							></p>
					  ))
			}
			<ButtonWrapperExtra>
				<Button
					text={translations['common__text__ok']}
					img={Validation}
					bgColor={theme.colors.validation}
					actionHandler={() => modalAction.tooltipHelpClose()}
				/>
			</ButtonWrapperExtra>
		</Modals>
	)
}

TooltipHelpModal.propTypes = {}

TooltipHelpModal.defaultPropTypes = {}

export default TooltipHelpModal
